import { render, staticRenderFns } from "./DeliveryConfirm.vue?vue&type=template&id=0af69785&scoped=true&"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryConfirm.vue?vue&type=style&index=0&id=0af69785&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af69785",
  null
  
)

export default component.exports